import ErrorUtils from 'utils/error-utils';
import SegmentUtils from 'utils/segment';
import getReservationStatus from 'segment/utils/reservation-status';
import UserUtils from 'utils/user-utils';

export const UPDATED_FIELDS = {
    LICENSE_PLATE: 'license_plate_updated',
    PHONE: 'phone_number_updated',
    CANCELLED: 'reservation_cancelled',
    TIMES: 'reservation_times_updated',
    VEHICLE: 'vehicle_updated',
};

export const LOCATIONS = {
    PARKING_PASS: 'Parking Pass',
};

export default function trackReservationUpdated({
    reservation,
    updatedProperties = [],
    location,
    extraTimePurchased = 0,
    reservationPriceChanged = 0,
    activeStatus,
    user,
}) {
    try {
        const {
            reservationType,
            currencyType,
            rentalId,
            facility: {allowUpdatingReservationAfterEntry},
            entryTimestamp,
            exitTimestamp,
            paymentStatus,
            partner,
            parkingPassType,
        } = reservation;
        const {status} = user;
        const reservationStatus = getReservationStatus({
            activeStatus,
            paymentStatus,
        });

        const properties = {
            cannot_adjust_after_entry: !allowUpdatingReservationAfterEntry,
            currency: currencyType.toLowerCase(),
            extra_time_purchased: extraTimePurchased,
            license_plate_updated: false,
            phone_number_updated: false,
            reservation_cancelled: false,
            reservation_price_changed: reservationPriceChanged,
            reservation_times_updated: false,
            location,
            parking_type: reservationType,
            rental_id: rentalId,
            vehicle_updated: false,
            is_scan2pay: false,
            scanned_in_time: entryTimestamp,
            scanned_out_time: exitTimestamp,
            reservation_status: reservationStatus,
            user_logged_in: status === UserUtils.AUTH_STATE.USER,
            partner: partner?.slug || null,
            parking_pass_type: parkingPassType,
        };

        updatedProperties.forEach(property => {
            properties[property] = true;
        });

        SegmentUtils.track({
            event: 'Reservation Updated',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage:
                'Segment Event Failed - trackReservationUpdated',
        });
    }
}
